import React from 'react'

import './styles.css'

export interface EmptyStateProps {
  icon?: React.ReactNode
  children: React.ReactNode
  callToAction?: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export default function EmptyState({
  icon,
  children,
  callToAction,
  className,
  style,
}: EmptyStateProps) {
  const mergedClassName = ['empty-state', className].filter(Boolean).join(' ')
  return (
    <div className={mergedClassName} style={style}>
      {icon && <span className="empty-state__icon">{icon}</span>}
      <p className="empty-state__body">{children}</p>
      {callToAction && <div className="empty-state__cta">{callToAction}</div>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/EmptyState/index.tsx